export interface Testimonial {
  name: string
  quote: string
}

export const TESTIMONIALS: Testimonial[] = [
  {
    name: 'Maddie, 29',
    quote: 'Finally, an app that actually works. I was so sick of swiping and chatting and never meeting anyone.',
  },
  {
    name: 'Jack, 27',
    quote: 'I just went out with my friends and used Ivy once I got there. Very easy. I didn’t waste any time swiping and met a real person when I was out.',
  },
  {
    name: 'Sarah, 34',
    quote: 'Having a map is cool. I can see where the single people are out from home while I was getting ready.',
  },
]
